const REPO_URL = `https://github.com/brandongregoryscott/beets`;

export { REPO_URL };
